import { Component, Input, OnInit } from '@angular/core';
import { AcionamentoSituacaoEnum, AcionamentoStatusEnum } from '@modules/consulta/produtos/assistencia-24h/enumerators';
import { StatusAutoDescriptionEnum } from '@modules/consulta/produtos/rnpa-auto/enumerators/status-auto.enum';

@Component({
  selector: 'ds-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {

  @Input() status: string | AcionamentoSituacaoEnum | AcionamentoStatusEnum | StatusAutoDescriptionEnum
  @Input() tooltip: string

  constructor() { }

  ngOnInit() {
  }

}
